import React, {Fragment} from 'react';
import {ConditionalRenderer} from "./ConditionalRenderer";

export let CheckBox = function (props) {
    function onChange() {
        props.onChange(!props.checked);
    }

    let idProps = {};
    if (props.id) {
        idProps.id = props.id;
    }

    return (
        <div
            {...idProps}
            className={`checkbox-container ${props.disabled ? 'disabled' : ''}`}
            onClick={props.disabled ? () => null : onChange}
        >
            <div
                className="common-form-checkbox"
            >
                {(() => {
                    if (props.checked) {
                        return (
                            <img
                                src="/static/images/check-textcolor.svg"
                                className="common-form-checkbox-check"
                            />
                        )
                    }
                })()}
            </div>
            <ConditionalRenderer if={props.label} renderer={() => (
                <div className="checkbox-label">{props.label}</div>
            )}/>
            <ConditionalRenderer if={props.disabled && props.sublabel} renderer={() => (
                <div className="checkbox-disabled-sublabel">{`(${props.sublabel})`}</div>
            )}/>
        </div>
    );
};
